import { GET_PAYMENT_TRANSFER_RESULT_RECORDS } from '../../constants/actions/payment';

export function getPaymentTransferResultRecords() {
    return {
        type: GET_PAYMENT_TRANSFER_RESULT_RECORDS,
    };
}
